import { useState } from 'react';

import { useRightsMatrix } from '../../api/hooks';
import type { MatrixColumnDimension, MatrixRowDimension } from '../../api/types';
import { FormField, Select } from '../../components/DesignSystem';

/** Matrix View: pivot of right counts by any row/column dimension pair. */
export function MatrixTab() {
  const [rows, setRows] = useState<MatrixRowDimension>('show');
  const [columns, setColumns] = useState<MatrixColumnDimension>('mediaType');

  const matrix = useRightsMatrix(rows, columns);
  const data = matrix.data;

  return (
    <>
      <div className="rfp-row" style={{ marginBottom: 22 }}>
        <FormField htmlFor="matrix-rows" label="Rows">
          <Select
            id="matrix-rows"
            onChange={(event) => setRows(event.target.value as MatrixRowDimension)}
            value={rows}
          >
            <option value="show">Show</option>
            <option value="territory">Territory</option>
            <option value="party">Party</option>
          </Select>
        </FormField>
        <FormField htmlFor="matrix-columns" label="Columns">
          <Select
            id="matrix-columns"
            onChange={(event) => setColumns(event.target.value as MatrixColumnDimension)}
            value={columns}
          >
            <option value="mediaType">Media Type</option>
            <option value="territory">Territory</option>
            <option value="rightType">Right Type</option>
          </Select>
        </FormField>
      </div>

      <section className="rfp-card">
        {matrix.isLoading ? (
          <p className="rfp-loading">Building matrix…</p>
        ) : matrix.isError ? (
          <p className="rfp-inline-error" role="alert">
            Could not load the matrix — please retry.
          </p>
        ) : (data?.rows.length ?? 0) === 0 ? (
          <p className="rfp-muted-text">No rights yet — the matrix fills in as rights are added.</p>
        ) : (
          <div className="rfp-table-scroll">
            <div className="rfp-table-card">
              <table className="rfp-table">
                <thead>
                  <tr>
                    <th scope="col">{rows}</th>
                    {(data?.columnKeys ?? []).map((columnKey) => (
                      <th className="rfp-table__cell--right" key={columnKey} scope="col">
                        {columnKey}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {(data?.rows ?? []).map((row) => (
                    <tr key={row.key}>
                      <td>{row.label}</td>
                      {(data?.columnKeys ?? []).map((columnKey) => (
                        <td className="rfp-table__cell--right" key={columnKey}>
                          {row.cells[columnKey] ?? <span className="rfp-table__null">—</span>}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </section>
    </>
  );
}
